///////////////////////////////////////////////////

import { secondaryProductsApiConnector } from 'apiConnector/secondary-market/product-search/searchProductsByCode';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, concatMap, mergeMap } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import {
  secondaryMarketProductCodeSearchFailed,
  secondaryMarketProductCodeSearchReceived as secondaryMarketProductKeySearchReceived,
  secondaryMarketProductCodeSearchReloaded as secondaryMarketProductKeysSearchReloaded,
} from 'state/secondaryMarket/productSearch';
import { notifySecondaryMarketProductsSearchResultThunk } from 'state/secondaryMarket/productSearch/productSearch.thunks';
import type { EpicWithThunk } from 'state/state.common';
import { extractHttpErrorMessage, extractTimeout } from 'utils/http/httpClient.model';

export function fetchProductsByKeysEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const { searchProductsByCode: searchProductsByBcsKeys } = secondaryProductsApiConnector(httpClient);

    return action$.pipe(
      ofType('SECONDARY_MARKET_PRODUCT_CODE_SEARCH_REQUESTED'),
      concatMap(({ keys, dlpKeys, isAutomaticRequest }) => {
        return searchProductsByBcsKeys({ keys, dlpKeys }).pipe(
          mergeMap(({ products }) => {
            const foundCount = products.length;
            const searchCount = keys.length;
            if (!isAutomaticRequest) {
              return of(
                secondaryMarketProductKeySearchReceived(products),
                notifySecondaryMarketProductsSearchResultThunk({ searchCount, foundCount }),
              );
            } else {
              return of(secondaryMarketProductKeysSearchReloaded(products));
            }
          }),
          catchError(err =>
            of(
              secondaryMarketProductCodeSearchFailed(extractHttpErrorMessage(err), extractTimeout(err)),
              showNotificationThunk({
                level: 'danger',
                title: { id: 'secondaryMarketProductSearch.technicalError.title' },
                content: [{ id: 'secondaryMarketProductSearch.technicalError.content' }],
                closeAutomatically: false,
                minWidth: 500,
              }),
            ),
          ),
        );
      }),
    );
  };
}
